<template>
  <div>
    <van-nav-bar title="配资交易" class="" />
    <van-tabs id="activeTabBarTwo" v-model="activeTab" href="1" style="padding-top: 10px">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-tab to="/create_capital_accounts">
          <template #title>
            <!-- <van-row style="width:100px;">
              <van-col span="12"><img style="width: 38px; padding-top: 5px"
                  src="../assets/images/home_day1.png" /></van-col>
              <van-col span="12" style="padding: 5px; padding-top: 15px">配资</van-col>
            </van-row> -->
            <div style="display: inline-flex; align-items: center;">
              <img style="width: 30px; margin: 20px 0px" src="../assets/images/home_day1_b.png" alt="" />
              <p style="padding-left: 15px;color:#000000">配资</p>
            </div>
          </template>
        </van-tab>

        <van-tab href="2">
          <template #title>
            <!-- <van-row style="width:100px;">
              <van-col span="12"><img style="width: 38px; padding-top: 5px"
                  src="../assets/images/home_month1.png" /></van-col>
              <van-col span="12" style="padding: 5px; padding-top: 15px">交易</van-col>
            </van-row> -->
            <div style="display: inline-flex; align-items: center">
              <img style="width: 30px; margin: 20px 0px" src="../assets/images/home_month1_o.png" alt="" />
              <p style="padding-left: 15px; color:#D02E27">交易</p>
            </div>
          </template>
          <van-tabs id="activeTabSub1">
            <van-tab title="当前配资">
              <van-list v-model="loadingCapitalAccount" :finished="finishedCapitalAccount" finished-text="">
                
                  <div v-for="(item, index) in currentList" :key="index" class="capitaldata">
                    <van-cell v-if="is_short_trading_enable == 1" class="capital-top">
                      <template #title>
                        <!-- Can do BOTH Trading -->
                        <div v-if="item.direction_capital == 2">
                          <p style="margin: 0">{{ item.name }} ({{ item.order }})</p>
                          <p style="margin: 0 0 8px 0">{{ item.time }}</p>

                            <div style="display: flex; justify-content: flex-end; gap: 10px">
                              <van-button
                                type="danger"
                                size="small"
                                style="border-radius: 10px; height: 26px; background-color: #D02E27;"
                                @click="$store.commit('setSelectedCid', item.cid); $router.push({ name: 'Trading', params: { direction: 0 }})"
                              >
                                做多交易
                              </van-button>

                              <van-button
                                type="danger"
                                size="small"
                                style="border-radius: 10px; height: 26px;background-color: #D02E27;"
                                @click="$store.commit('setSelectedCid', item.cid); $router.push({ name: 'TradingDirection', params: { direction: 1 }})"
                              >
                                做空交易
                              </van-button>
                                <router-link to="/account_details" style="display: flex">
                                <van-button
                                  type="danger"
                                  size="small"
                                  style="border-radius: 10px; height: 26px;background-color: #D02E27;"
                                  @click="goAccountDetails(item.cid)"
                                >
                                  账户信息
                                </van-button>
                              </router-link>
                          </div>

                        </div>
                        <!-- Can do SHORT Trading only -->
                        <div v-if="item.direction_capital == 1">
                          <p style="margin: 0">{{ item.name }} ({{ item.order }})</p>
                          <p style="margin: 0 0 8px 0">{{ item.time }}</p>

                            <div style="display: flex; justify-content: flex-end; gap: 10px">
                              <van-button
                                type="danger"
                                size="small"
                                style="border-radius: 10px; height: 26px;background-color: #D02E27;"
                                @click="$store.commit('setSelectedCid', item.cid); $router.push({ name: 'TradingDirection', params: { direction: 1 }})"
                              >
                                做空交易
                              </van-button>
                                <router-link to="/account_details" style="display: flex">
                                <van-button
                                  type="danger"
                                  size="small"
                                  style="border-radius: 10px; height: 26px;background-color: #D02E27;"
                                  @click="goAccountDetails(item.cid)"
                                >
                                  账户信息
                                </van-button>
                              </router-link>
                          </div>

                        </div>
                        <!-- Can do LONG Trading only -->
                        <div v-if="item.direction_capital == 0">
                          <p style="margin: 0">{{ item.name }} ({{ item.order }})</p>
                          <p style="margin: 0 0 8px 0">{{ item.time }}</p>

                            <div style="display: flex; justify-content: flex-end; gap: 10px">
                              <router-link to="/ai_trade_depot" style="display: flex" v-if="is_ai_trading_enable == 1">
                                <button class="aiTradingBtn" @click="goAITradeDepot(item.cid)">
                                  <svg class="aiIcon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                      d="M12 2L13.8 8.2L20 10L13.8 11.8L12 18L10.2 11.8L4 10L10.2 8.2L12 2Z"
                                      fill="currentColor"
                                    />
                                    <path
                                      d="M19 14L19.7 16.3L22 17L19.7 17.7L19 20L18.3 17.7L16 17L18.3 16.3L19 14Z"
                                      fill="currentColor"
                                    />
                                  </svg>
                                  <span>AI Trading</span>
                                </button>
                              </router-link>

                              <van-button
                                type="danger"
                                size="small"
                                style="border-radius: 10px; height: 26px; background-color: #D02E27;"
                                @click="$store.commit('setSelectedCid', item.cid); $router.push({ name: 'Trading', params: { direction: 0 }})"
                              >
                                做多交易
                              </van-button>

                              <router-link to="/account_details" style="display: flex">
                                <van-button
                                  type="danger"
                                  size="small"
                                  style="border-radius: 10px; height: 26px;background-color: #D02E27;"
                                  @click="goAccountDetails(item.cid)"
                                >
                                  账户信息
                                </van-button>
                              </router-link>
                          </div>

                        </div>
                      </template>
                    </van-cell>

                    <van-cell v-if="is_short_trading_enable == 0" class="capital-top">
                      <template #title>
                        <p style="margin: 0px">
                          {{ item.name }} ({{ item.order }})
                        </p>
                        <p style="margin: 0px">{{ item.time }}</p>
                      </template>
                      <template #default>
                        <span><van-button type="danger" size="small" style="
                              border-radius: 10px;
                              margin-top: 14px;
                              height: 26px;
                              background-color: #D02E27;
                            "
                            @click="$store.commit('setSelectedCid', item.cid); $router.push({ name: 'Trading', params: {} })">交易股票</van-button>
                          <router-link to="/account_details"><van-button type="danger" size="small" style="
                                border-radius: 10px;
                                margin-top: 14px;
                                height: 26px;
                                background-color: #D02E27;
                              " @click="goAccountDetails(item.cid)">账户信息</van-button></router-link>
                        </span>
                      </template>
                    </van-cell>

                    <van-cell title="当前总资产" style="padding: 5px 16px">
                      <template #default>
                        <span style="color: black">{{ item.total }}元</span>
                      </template>
                    </van-cell>
                    <van-cell title="亏损警戒线 (亏损比)" style="padding: 5px 16px">
                      <template #default>
                        <span style="color: #D02E27">{{ item.warning }}元 ({{ item.warning_line_ratio }})</span>
                      </template>
                    </van-cell>
                    <van-cell title="亏损平仓线（亏损比）" style="padding: 5px 16px">
                      <template #default>
                        <span style="color: #3F7A21">{{ item.close }}元 ({{ item.close_line_ratio }})</span>
                      </template>
                    </van-cell>
                    <van-cell title="风险保证金" style="padding: 5px 16px">
                      <template #default>
                        <span style="color: black">{{ item.bond }}元</span>
                      </template>
                    </van-cell>
                    <van-cell title="浮动盈亏" style="padding: 5px 16px">
                      <template #default>
                        <span v-if="item.profit_loss < 0" style="color: #3F7A21">{{ item.profit_loss }}元 ({{
                            item.proportion
                        }}%)</span>
                        <span v-else style="color: #D02E27">{{ item.profit_loss }}元 ({{ item.proportion }}%)</span>
                      </template>
                    </van-cell>
                    <van-cell title="可用余额" style="padding: 5px 16px">
                      <template #default>
                        <span style="color: #D02E27">{{ item.use }}元</span>
                      </template>
                    </van-cell>
                    <div class="optionList" id="bottomRow">
                      <van-row style=" text-align: center">

                        <van-col span="6" style="color: #D02E27;" @click="onSelectIncreaseCapitalInfo(item.total, item.order, item.cid)"
                          ><span class="text-border">追加配资</span></van-col
                        >

                        <van-col span="6" style="color: #D02E27" @click="onSelectIncreaseBondInfo(item.total, item.order, item.cid)"
                          ><span class="text-border">追加保证金</span></van-col
                        >

                        <van-col span="6" style="color: #D02E27" @click="closeCapitalAccount(item.cid)"
                          ><span class="text-border">申请结算</span></van-col
                        >

                        <van-col span="6" style="color: #D02E27" @click="capitalFundDetails(item.cid)"
                          ><span class="text-border">资金明细</span></van-col
                        >
                        <!-- <van-col
                          span="6"
                          style="background: #ee0d25; color: #ffffff"
                          @click="
                            $store.commit('setSelectedCid', cid);
                            $router.push({ name: 'Trading', params: {} });
                          "
                          ><span>交易委托</span></van-col
                        > -->
                      </van-row>
                    </div>
                  </div>
                
              </van-list>
            </van-tab>
            <van-tab title="历史配资">
              <van-cell-group>
                <router-link to="/closed_capital_info">
                  <div v-for="(item, index) in list" :key="index" @click="goDetails(item.cid)">
                    <van-cell>
                      <van-row>
                        <van-col span="24">
                          <span style="font-size: 15px; color: black">{{ item.name }}({{ item.order }})</span>
                        </van-col>
                      </van-row>
                      <van-row style="line-height: 21px;">
                        <van-col span="20">
                          <van-row>
                            <van-col span="24">
                              <span style="font-size: 13px; color: #808080">{{
                                  item.time
                              }}</span>
                            </van-col>
                          </van-row>
                          <van-row>
                            <van-col span="12">
                              <span style="font-size: 13px; color: #808080">总配资资金:{{ item.total }}</span>
                            </van-col>
                            <van-col span="12">
                              <span style="font-size: 13px; color: #808080">风险保证金:{{ item.bond }}</span>
                            </van-col>
                          </van-row>
                          <van-row>
                            <van-col span="24">
                              <span style="font-size: 15px; color: black">累计盈亏:</span><span
                                v-bind:class="[item.profit >= 0 ? 'redText' : 'greenText']"
                                style="font-size: 15px; padding-left: 10px;">{{
      item.profit
                                }}</span>
                            </van-col>
                          </van-row>
                        </van-col>
                        <van-col span="4">
                          <van-row>
                            <van-col span="24" style="text-align: right">
                              <img style="height: 50px; width: 50px" src="../assets/images/over.png" />
                            </van-col>
                          </van-row>
                        </van-col>
                      </van-row>
                    </van-cell>
                  </div>
                </router-link>
              </van-cell-group>
              <div style="margin-top: 25px; margin-bottom: 25px; color: #D02E27; font-weight: bold;text-align: center;">
          只显示最近12个月记录
        </div>
            </van-tab>
          </van-tabs>
        </van-tab>
      </van-pull-refresh>
    </van-tabs>
  </div>
</template>

<script>
import $ from "jquery";
import Vue from "vue";
import { Dialog } from "vant";
Vue.use(Dialog);
export default {
  name: "CapitalAccount",
  mounted: function () {
    this.getHistoryData();
    this.getNowData();
    this.isActiveTab();
    this.fetch_is_short_trading_enable();
    this.fetch_is_ai_trading_enable();
    this.activeTab = this.tabs.findIndex(
      (tab) => tab === this.$route.query.activeTab
    );
  },
  data() {
    return {
      activeTab: "0",
      tabs: ["1", "2"],
      list: [],
      currentList: [],
      loadingCapitalAccount: false,
      finishedCapitalAccount: false,
      isLoading: false,
      is_short_trading_enable : 0,
      capital_direction : 2,
      is_ai_trading_enable : 1,
    };
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.getHistoryData();
        this.getNowData();
        this.isActiveTab();
        this.activeTab = this.tabs.findIndex(
          (tab) => tab === this.$route.query.activeTab
        );
        this.isLoading = false;
      }, 1000);
    },
    onSelectIncreaseCapitalInfo(total, order, cid) {
      sessionStorage.setItem('cid', cid)
      localStorage.setItem("isCapitalPage", true);

      this.$router.push({
          name: "IncreaseCapitalInfo",
          params: { total: total, order: order },
        });
    },
    onSelectIncreaseBondInfo(total, order, cid) {
      sessionStorage.setItem('cid', cid)
      localStorage.setItem("isCapitalPage", true);

      this.$router.push({
          name: "IncreaseBondInfo",
          params: { total: total, order: order },
        });
    },
    capitalFundDetails(cid) {
      sessionStorage.setItem('cid', cid)
      localStorage.setItem("isCapitalPage", true);
      
      this.$router.push({
          name: "CapitalFundDetails",
          params: { },
        });
    },  
    closeCapitalAccount(cid) {
      Dialog.confirm({
        title: "申请结算",
        message: "您是否确定结算该合约?",
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      })
        .then(() => {
          // on confirm
          this.operationSettlement(cid);
        })
        .catch(() => {
          // on cancel
        });
    },
    //申请结算 - 操作
    operationSettlement(cid) {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "settlement",
            token: sessionStorage.getItem("token"),
            cid: cid,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$toast.success({
              message: res.data.msg,
              type: "success",
              duration: 1000,
            });
            that.$store.commit('setSelectedCid', '');
            that.$router.push({
              path: "capital_account?activeTab=2",
            });
            that.getHistoryData();
            that.getNowData();
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    isActiveTab() {
      let that = this;
      if (!that.$route.query.activeTab) {
        that.activeTab = "2";
      } else {
        that.activeTab = that.$route.query.activeTab;
      }
    },
    getHistoryData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "history_operate",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.list = res.data.data;
            // if (that.list.length == 0) {
            //   that.$toast({
            //     message: "暂无记录",
            //     type: "warning",
            //   });
            // }
          } else if (res.data.code == 0) {
            tthat.$toast.fail(res.data.msg);
          }
        });
    },
    getNowData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "current_operate",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.currentList = res.data.data;
            that.loadingCapitalAccount = false;
            that.finishedCapitalAccount = true;
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          } else if (res.data.code == -1) {
            that.$logout(res.data.msg);
          }
        })
        .catch(() => {
          that.loadingCapitalAccount = false;
          that.finishedCapitalAccount = true;
        });
    },
    //去详情
    goDetails(cid) {
      window.sessionStorage.setItem("cid", cid);
      this.$router.push({
        path: "/closed_capital_info",
      });
    },
    goAccountDetails(cid) {
      window.sessionStorage.setItem("cid", cid);
      this.$router.push({
        path: "/account_details",
      });
    },
    goAITradeDepot(cid) {
      window.sessionStorage.setItem("cid", cid);
      this.$router.push({
        path: "/ai_trade_depot",
      });
    },
     fetch_is_short_trading_enable() {
      let that = this;
      that.$http({
        url: "/",
        method: "POST",
        data: {
          nozzle: 'sysconfig',
          name: 'is_short_trading_enable'
        }
      })
        .then(ret => {
          let resData = ret.data;
          console.log(resData)
          if (resData.code === 1) {
            that.is_short_trading_enable = resData.data;
          }
        });
    },
     fetch_is_ai_trading_enable() {
      let that = this;
      that.$http({
        url: "/",
        method: "POST",
        data: {
          nozzle: 'sysconfig',
          name: 'is_ai_trading_enable'
        }
      })
        .then(ret => {
          let resData = ret.data;
          console.log(resData)
          if (resData.code === 1) {
            that.is_ai_trading_enable = resData.data;
          }
        });
    },
  },
};
</script>
<style>

#activeTabBarTwo .van-tabs__nav--line {
  margin: 10px 10px;
  padding: 10px;
  height: 20px;
  background: #f0f0f0;
  border-radius: 10px;
}
#activeTabSub1{

}
#activeTabSub1 .van-tabs__nav--line {
  margin: 5px 10px;
  padding: 10px;
  height: 20px;
  background: #ffffff !important;
  border-radius: 0px !important;
}

#activeTabBarTwo .van-tab--active {
  border: none !important;
  border-left: 1px solid #abafba !important;
}

#activeTabBarTwo .van-tabs__line {
  display: none;
}
#activeTabBarTwo.van-tabs--line .van-tabs__wrap{
  height:50px !important;
}
#activeTabSub1 .van-tab {
  justify-content: flex-start !important;
  text-align: left !important;
  padding-right: 70px !important; 
  color: #000000 !important; /* Ensure default tab color is black */
}

#activeTabSub1 .van-tabs__wrap {
  display: flex;
}
#activeTabSub1 .van-tab--active {
  border: none !important;
  color: #D02E27 !important;
}

/* #activeTabSub1 .van-tab--active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 50%;
  height: 3px;
  background-color: #D02E27;
  transform: translateX(-50%);
} */
</style>
<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.redText {
  color: #D02E27;
}

.greenText {
  color: #3F7A21;
}

.optionList {
  text-align: center;
  /* position: fixed; */
  /* bottom: 50px; */
  width: 100%;
  /* height: 60px; */
  line-height: 40px;
  background: #ffffff;
  font-size: 12px;
}

.text-border {
  border: 1px solid #D02E27;
  padding: 5px;
  border-radius: 10px;
}
.capital-top{
  background-color: #f0f0f0;
  color: rgb(4, 4, 4);
  padding: 2px 15px 10px;
}
.capitaldata{
  margin:0px 10px 5px 10px !important;
  border:1px solid #e3e3e3!important;
  border-radius: 15px !important;
  overflow: hidden;
}
.aiTradingBtn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 26px;
  padding: 0 12px;
  border: none;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
  background: linear-gradient(135deg, #652b29 0%, #D02E27 100%);
  box-shadow: 0 2px 6px rgba(106, 92, 255, 0.35);
  cursor: pointer;
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.aiTradingBtn:active {
  opacity: 0.85;
  transform: scale(0.97);
}

.aiIcon {
  width: 13px;
  height: 13px;
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/components/CapitalAccount.vue